import { PageHeader, Spin, Popconfirm, message, Tag, Alert } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { TableItem, ButtonItem, HeaderActions } from "../../../../Components/Items";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { ALCANCE } from "../../../../Utils/reglasPrecio";
import ModalReglaPrecio from "./ModalReglaPrecio/ModalReglaPrecio";

// "-" y no vacio: distingue "no lo define, se hereda" de una celda en blanco.
const opcional = (valor, sufijo = "") =>
  valor === null || valor === undefined || valor === "" ? "-" : `${valor}${sufijo}`;

class ReglasListasDePrecios extends Component {
  state = {
    loading: false,
    reglas: [],
    precios: [],
    priorizarReglasTipoCliente: false,
    filtroAlcance: 0,
    modalRegla: false,
    modoModal: "agregar",
    reglaEditar: null,
  };

  componentDidMount() {
    this.consultarReglas();
  }

  consultarReglas() {
    this.setState({ loading: true });
    axios
      .post(
        "reglasPrecio/selectReglasPrecio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            reglas: res.data.reglas,
            precios: res.data.precios,
            priorizarReglasTipoCliente: res.data.priorizarReglasTipoCliente,
          });
        } else {
          this.setState({ reglas: [] });
          message.error("No se pudieron cargar las reglas");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error al cargar las reglas");
      });
  }

  eliminarRegla(reglaId) {
    this.setState({ loading: true });
    axios
      .post(
        "reglasPrecio/eliminarReglaPrecio",
        { empresaId: this.props.empresaId, reglaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se elimino la regla");
          this.consultarReglas();
        } else {
          message.error(res.data.message || "No se pudo eliminar la regla");
        }
      });
  }

  // La regla completa viaja desde el renglon de la tabla: selectReglasPrecio ya
  // trae todos sus campos, asi que un endpoint extra para leer una sola sobra.
  abrirModal(modo, regla) {
    this.setState({ modalRegla: true, modoModal: modo, reglaEditar: regla || null });
  }

  cerrarModal(recargar) {
    this.setState({ modalRegla: false, reglaEditar: null });
    if (recargar) this.consultarReglas();
  }

  render() {
    const reglasFiltradas = this.state.filtroAlcance
      ? this.state.reglas.filter(
          (regla) => Number(regla.alcance) === this.state.filtroAlcance
        )
      : this.state.reglas;

    const columns = [
      {
        title: "Lista",
        dataIndex: "lista",
        key: "lista",
        buscar: "lista",
        sorter: (a, b) => (a.lista || "").localeCompare(b.lista || ""),
      },
      {
        title: "Alcance",
        dataIndex: "alcanceNombre",
        key: "alcanceNombre",
        render: (texto, record) => {
          const colores = { 1: "default", 2: "blue", 3: "purple" };
          return <Tag color={colores[record.alcance]}>{texto}</Tag>;
        },
      },
      {
        title: "Aplica a",
        dataIndex: "aplicaA",
        key: "aplicaA",
        buscar: "aplicaA",
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        render: (texto) => texto || "Todas",
      },
      {
        title: "Marca",
        dataIndex: "marca",
        key: "marca",
        render: (texto) => texto || "Todas",
      },
      {
        title: "%",
        dataIndex: "porcentaje",
        key: "porcentaje",
        align: "right",
        render: (valor) => opcional(valor, "%"),
      },
      {
        title: "Margen min",
        dataIndex: "margenMinimo",
        key: "margenMinimo",
        align: "right",
        render: (valor) => opcional(valor, "%"),
      },
      {
        title: "Margen max",
        dataIndex: "margenMaximo",
        key: "margenMaximo",
        align: "right",
        render: (valor) => opcional(valor, "%"),
      },
      {
        title: "Desc min",
        dataIndex: "descuentoMinimo",
        key: "descuentoMinimo",
        align: "right",
        render: (valor) => opcional(valor, "%"),
      },
      {
        title: "Desc max",
        dataIndex: "descuentoMaximo",
        key: "descuentoMaximo",
        align: "right",
        render: (valor) => opcional(valor, "%"),
      },
      {
        title: "Escalas",
        dataIndex: "numeroEscalas",
        key: "numeroEscalas",
        align: "center",
        render: (valor) => (valor ? <Tag color="gold">{valor}</Tag> : "-"),
      },
      {
        title: "Accion",
        key: "accion",
        fixed: "right",
        align: "center",
        render: (valor, record) => (
          <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
            <ButtonItem
              icon={<EditOutlined />}
              type="primary"
              onClick={() => this.abrirModal("editar", record)}
            />
            <Popconfirm
              title="Seguro que quieres eliminar esta regla?"
              onConfirm={() => this.eliminarRegla(record._id)}
              okText="Eliminar"
              cancelText="Cancelar"
            >
              <ButtonItem rojo2 icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        ),
      },
    ];

    return (
      <>
        <PageHeader
          title="Reglas de Listas de Precios"
          onBack={() => this.props.history.goBack()}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <div key="acciones" style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <HeaderActions>
                <ButtonItem
                  onClick={() => this.setState({ filtroAlcance: 0 })}
                  type={this.state.filtroAlcance === 0 ? "primary" : "default"}
                >
                  Todas
                </ButtonItem>
                <ButtonItem
                  onClick={() => this.setState({ filtroAlcance: ALCANCE.LISTA })}
                  type={this.state.filtroAlcance === ALCANCE.LISTA ? "primary" : "default"}
                >
                  Lista base
                </ButtonItem>
                <ButtonItem
                  onClick={() => this.setState({ filtroAlcance: ALCANCE.TIPO_CLIENTE })}
                  type={
                    this.state.filtroAlcance === ALCANCE.TIPO_CLIENTE ? "primary" : "default"
                  }
                >
                  Tipo de cliente
                </ButtonItem>
                <ButtonItem
                  onClick={() => this.setState({ filtroAlcance: ALCANCE.CLIENTE })}
                  type={this.state.filtroAlcance === ALCANCE.CLIENTE ? "primary" : "default"}
                >
                  Cliente
                </ButtonItem>
              </HeaderActions>
              <ButtonItem
                onClick={() => this.abrirModal("agregar")}
                icon={<PlusOutlined />}
                type="primary"
                className="botonAgregar"
              >
                Agregar Regla
              </ButtonItem>
            </div>,
          ]}
        />

        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 10 }}
          message={
            this.state.priorizarReglasTipoCliente
              ? "Precedencia actual: lista base, luego cliente, y al final tipo de cliente (el tipo de cliente gana)."
              : "Precedencia actual: lista base, luego tipo de cliente, y al final cliente (el cliente gana)."
          }
          description="Dentro de cada nivel, una regla por marca gana sobre una por familia, y esa sobre la general. Un campo vacio hereda del nivel anterior; solo se pisa lo que la regla define. Se cambia en Configuracion > Insumos."
        />

        <Spin spinning={this.state.loading}>
          <TableItem size="small" dataSource={reglasFiltradas} columns={columns} />
        </Spin>

        <ModalReglaPrecio
          visible={this.state.modalRegla}
          modo={this.state.modoModal}
          regla={this.state.reglaEditar}
          onClose={(recargar) => this.cerrarModal(recargar)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReglasListasDePrecios);
